import { render } from "./IpcSection.vue?vue&type=template&id=ede7512c"
import script from "./IpcSection.vue?vue&type=script&lang=js"
export * from "./IpcSection.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__